export enum Interval {
  FASTEST = 500,
  VERYFAST = 1000,
  FAST = 3000,
  NORMAL = 6000,
  SLOW = 10000,
}
